require('./index.css')




// WEBPACK FOOTER //
// ./layout/single/index.js